// extracted by css-extract-rspack-plugin
export default {"Explanation":"ModelPersistenceConfiguration-module__Explanation___QFoNI"};